/**
 * Session management — API key in sessionStorage.
 * Cleared when browser tab closes.
 */

const SESSION_KEY = "ksef_auth_api_key";

interface SessionData {
  readonly apiKey: string;
  readonly timestamp: number;
}

export const setSession = (apiKey: string): void => {
  const data: SessionData = { apiKey, timestamp: Date.now() };
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
};

/** Maximum session age: 8 hours */
const MAX_SESSION_AGE_MS = 8 * 60 * 60 * 1000;

export const getSession = (): string | null => {
  const stored = sessionStorage.getItem(SESSION_KEY);
  if (!stored) {
    return null;
  }
  try {
    const data: SessionData = JSON.parse(stored);
    if (Date.now() - data.timestamp > MAX_SESSION_AGE_MS) {
      clearSession();
      return null;
    }
    return data.apiKey;
  } catch {
    clearSession();
    return null;
  }
};

export const clearSession = (): void => {
  sessionStorage.removeItem(SESSION_KEY);
};

export const hasSession = (): boolean => getSession() !== null;
